<template>
  <v-select-with-validation
    v-bind="$attrs"
    v-on="$listeners"
    class="region-select"
    :items="items"
    attach
  >
    <template v-slot:item="{ item }">
      <v-list-item-content
        :class="item.class"
      >
          {{ $t(item[itemText]) }}
      </v-list-item-content>
    </template>
  </v-select-with-validation>

</template>

<style scoped lang="scss">
  @import '~vuetify/src/styles/settings/colors';

  .region-select ::v-deep {
    .v-select-list {
      .v-subheader {
        background-color: map-get($blue, 'base') !important;
        border-color: map-get($blue, 'base') !important;
        color: map-get($shades, 'white') !important;
        caret-color: map-get($shades, 'white') !important;
      }
    }
  }

</style>

<script>
  import collect from 'collect.js';
  import { all } from '@/api/region'

  export default {
    name: 'RegionSelect',
    props: {
      itemText: {
        type: String,
        default() {
          return 'text';
        },
      },
      itemValue: {
        type: String,
        default() {
          return 'value';
        },
      },
    },
    data() {
      return {
        regions: [],
        loading: false,
      };
    },
    computed: {
      items() {
        return [
          { [this.itemText]: this.$t('All Locations'), [this.itemValue]: null, class: 'font-weight-bold' },
          ...this.regions,
        ];
      },
    },
    methods: {
      async fetch() {
        try {
          this.loading = true;
          this.regions = collect(await all()).map(value => ([
            { header: value.group },
            ...collect(value.items).map(item => ([
              {
                ...collect(item).except('children').all(),
                class: 'font-weight-bold',
              },
              ...item.children.map(child => ({
                ...child,
                class: 'font-weight-regular pl-3',
              })),
            ]))
              .collapse()
              .values()
              .all()
          ]))
            .collapse()
            .values()
            .all();
        } catch (e) {
          console.log(e);
        } finally {
          this.loading = false;
        }
      },
    },
    mounted() {
      this.fetch();
    },
  };
</script>

